
export const RICH_TEXT_TYPE_DRAFT_JS = "DraftJS";
export type RichText = {
  type: RICH_TEXT_TYPE_DRAFT_JS;
  content: string;
}
